// extracted by mini-css-extract-plugin
export default {"craftSection":"CraftSection_craftSection__WuOUc","cardContainer":"CraftSection_cardContainer__qpGRE"};